import React, { useState } from 'react';

const Tabs = (props) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    
    //const activeTab = props.children[activeTabIndex];
    //<div className={"tab-content " + props.tabContentClassName}>{activeTab.props.children}</div>

    const setActiveTab = (index) => {
        if (index !== activeTabIndex) {
            props.onChange(index)
            setActiveTabIndex(index)      
        }
    }

    React.useEffect(() => {
        if (props.selectedTab && activeTabIndex !== props.selectedTab)
            setActiveTabIndex(props.selectedTab)

    }, [props, activeTabIndex]);

    return (
        <>
            <div className={"tabs " + props.tabClassName}>
                <ul>
                    {props.children.map((tab, i) => (
                        <li key={"tab_" + i} className={i === activeTabIndex ? 'is-active' : ''} onClick={() => setActiveTab(i)}>
                            <a href={`#${tab.props.title}`}>{tab.props.title}</a>
                        </li>
                    ))}
                </ul>
            </div>

            
            <div className={"tab-content " + props.tabContentClassName}>
                {props.children.map((tab, i) => (
                    <div  key={"tab_content_" + i} className={i === activeTabIndex ? 'show-tab' : 'hide-tab'}>
                        {tab.props.children}
                    </div>
                ))}
            </div>


        </>
    );
}

export default Tabs